/**
 * OPTIONAL: Direct URLs to SYM Machinery's public Instagram posts or reels.
 * No login or API token is necessary to embed individual public posts.
 * Instagram does not expose the full list of posts from a profile URL alone.
 *
 * Example (replace with REAL published URLs):
 * export const instagramPostLinks = [
 *   { url: "https://www.instagram.com/reel/REAL_SHORTCODE/", title: "TERRA35 demonstration", thumbnail: "/images/terra35-demo.webp" },
 *   { url: "https://www.instagram.com/p/REAL_SHORTCODE/", title: "New machine delivery" },
 * ];
 *
 * Optional thumbnail should be an image owned/licensed by your business.
 * Add more URLs here whenever you want them available in the on-site Load More gallery.
 */
export const instagramPostLinks = [];
